import { DefaultTheme } from 'styled-components';
import { useAppContext } from '../hooks/useAppContext';
import { hasFeature, FeatureFlag } from '../helpers/featureFlags';
import { defaultTheme, defaultBranding } from './default';
import { alluviumTheme, alluviumBranding } from './alluviumTheme';

export interface Branding {
  primaryColor: string;
  primaryColorHover: string;
  primaryColorActive: string;
  darkAccent: string;
  headerDarkBg: string;
  headerPrimaryBg: string;
  tableHeaderBg: string;
  tableHeaderColor: string;
  logoPath: string;
  logoIconPath: string;
  logoWidth: string;
  goldAccent?: string;
  brandAccent?: string;
}

export const THEME_CACHE_KEY = 'blockit_theme_alluvium';

export function useBlockitTheme(): { theme: DefaultTheme; branding: Branding; isAlluvium: boolean } {
  const { currentOrganization } = useAppContext();

  // Once org data loads, use the feature flag as source of truth and cache the result
  if (currentOrganization?.featureFlags) {
    const isAlluvium = hasFeature(currentOrganization.featureFlags, FeatureFlag.AlluviumRebrand);
    try {
      localStorage.setItem(THEME_CACHE_KEY, isAlluvium ? '1' : '0');
    } catch (e) {
      // localStorage may be unavailable
    }
    return {
      theme: isAlluvium ? alluviumTheme : defaultTheme,
      branding: isAlluvium ? alluviumBranding : defaultBranding,
      isAlluvium,
    };
  }

  // Before org data is available, fall back to cached preference to avoid theme flash
  let cached = false;
  try {
    cached = localStorage.getItem(THEME_CACHE_KEY) === '1';
  } catch (e) {
    // localStorage may be unavailable
  }

  return {
    theme: cached ? alluviumTheme : defaultTheme,
    branding: cached ? alluviumBranding : defaultBranding,
    isAlluvium: cached,
  };
}
